<template>
  <div id="global-search" v-loading="loading">
    <div class="container-sm">
      <div class="global-search-collapse-block">
        <div class="global-search-body">
          <div>
            <ul class="global-list">
              <li class="checkbox-header">CHOOSE DATE TYPE</li>
              <li class="ml-30 radio-block">
                <label>
                  <input
                    type="checkbox"
                    class="input-checkbox"
                    value="collection_date"
                    v-model="date_check"
                    @change="uniqueCheck"
                  />
                  <h3>COLLECTION</h3>
                </label>
                <label>
                  <input
                    type="checkbox"
                    value="received_date"
                    class="input-checkbox"
                    v-model="date_check"
                    @change="uniqueCheck"
                  />
                  <h3>RECEIVED</h3>
                </label>
                <label>
                  <input
                    type="checkbox"
                    value="finalized_date"
                    class="input-checkbox"
                    v-model="date_check"
                    @change="uniqueCheck"
                  />
                  <h3>REPORTED</h3>
                </label>
                <label>
                  <input
                    type="checkbox"
                    value="amended_date"
                    class="input-checkbox"
                    v-model="date_check"
                    @change="uniqueCheck"
                  />
                  <h3>AMENDED</h3>
                </label>
              </li>
            </ul>
          </div>
          <div class="global-search-creation__body">
            <div class="vue-form">
              <el-form ref="ruleForm">
                <el-row :gutter="15">
                  <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">{{
                          "Select " + getDateType + " Date"
                        }}</label>

                        <el-date-picker
                          type="date"
                          v-model="start_date"
                          format="MM-DD-YYYY"
                          value-format="YYYY-MM-DD"
                          placeholder="Select Start Date"
                          :picker-options="datePickerOptions"
                          :editable="false"
                          :default-value="startDate"
                          @focus="checkDateValue"
                          :disabled-date="disabledDate"
                          clearable
                        ></el-date-picker>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">&nbsp;</label>
                        <el-date-picker
                          type="date"
                          v-model="end_date"
                          format="MM-DD-YYYY"
                          value-format="YYYY-MM-DD"
                          placeholder="Select To Date"
                          :picker-options="datePickerOptions"
                          :editable="false"
                          :default-value="presentDate"
                          @focus="checkDateValue"
                          :disabled-date="disabledDate"
                          clearable
                        ></el-date-picker>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">Patient Name</label>

                        <el-input
                          v-model="patient_name"
                          placeholder="Enter Patient Name"
                          class="el-input"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="5" :lg="5" :md="6" :sm="12" :xs="12">
                    <div class="date-of-birth each-case-edit">
                      <div class="date-of-birth case-creation__input">
                        <dobVersion
                          v-if="showDob"
                          :dobData="details"
                          ref="dobField"
                          :displayRequired="false"
                        ></dobVersion>
                      </div>
                    </div>
                  </el-col>
                  <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">Select Case Type</label>
                        <div
                          class="form-element search-with-filter-input"
                          v-if="
                            getAuthenticatedUser.user_type ==
                              'LAB_TECHNOLOGIST' &&
                            getAuthenticatedUser.allowed_case_types
                          "
                        >
                          <el-select
                            placeholder="Select Case Type"
                            v-model="search_case_type"
                            multiple
                            clearable
                            collapse-tags
                            filterable
                            @clear="clearTestInfo"
                            :reserve-keyword="false"
                          >
                            <el-option
                              v-for="caseType in getUserBasedCaseTypes(
                                caseTypes
                              )"
                              :key="caseType"
                              :label="caseType.label"
                              :value="caseType.value"
                            ></el-option>
                          </el-select>
                        </div>
                        <div
                          class="form-element search-with-filter-input"
                          v-else
                        >
                          <el-select
                            placeholder="Select Case Type"
                            v-model="search_case_type"
                            multiple
                            clearable
                            collapse-tags
                            filterable
                            @clear="clearTestInfo"
                            :reserve-keyword="false"
                            @remove-tag="removeCovidStatus"
                          >
                            <el-option
                              v-for="caseType in getLabBasedCaseTypes(
                                caseTypes
                              )"
                              :key="caseType"
                              :label="caseType.label"
                              :value="caseType.value"
                            ></el-option>
                          </el-select>
                        </div>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col
                    :xl="3"
                    :lg="3"
                    :md="8"
                    :sm="12"
                    :xs="12"
                    v-if="selectedCovidPanel"
                  >
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">Covid Status</label>
                        <el-select
                          placeholder="Select Covid Status"
                          v-model="search_covid_status"
                          filterable
                          clearable
                        >
                          <el-option
                            v-for="(item, index) in covidStatuses"
                            :key="index"
                            :value="item.value"
                            :label="item.label"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="3" :md="3" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">Case Status</label>
                        <div class="gender-select">
                          <el-select
                            placeholder="Select Status"
                            v-model="search_case_status"
                            clearable
                            filterable
                            default-first-option
                          >
                            <el-option
                              v-for="(item, index) in caseStatuses"
                              :key="index"
                              :value="item.value"
                              :label="item.label"
                            ></el-option>
                          </el-select>
                        </div>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">Accession#</label>
                        <el-input
                          v-model="accessionId"
                          placeholder="Enter Accession"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="4" :lg="4" :md="3" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">Select Ordering Facility</label>
                        <div class="gender-select">
                          <el-select
                            v-model="search_hospital"
                            placeholder="Select Ordering Facility"
                            @change="updatePhysicians"
                            clearable
                            filterable
                            default-first-option
                            @focus="fetchHospitals"
                            :loading="hospitalsLoading"
                            multiple
                            collapse-tags
                          >
                            <el-option
                              v-for="(hospital, index) in hospitalsData.data"
                              :key="index"
                              :label="hospital.name"
                              :value="hospital._id"
                            ></el-option>
                          </el-select>
                        </div>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="4" :lg="4" :md="3" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">Select Physician</label>
                        <div class="gender-select">
                          <el-select
                            v-model="search_ordering_physician"
                            placeholder="Select Ordering Physician"
                            clearable
                            filterable
                            default-first-option
                            :loading="physiciansLoading"
                            remote
                            :remote-method="remoteMethodPhysician"
                          >
                            <el-option
                              v-for="physician in physiciansData.data"
                              :key="physician"
                              :label="physician.name"
                              :value="physician._id"
                            ></el-option>
                          </el-select>
                        </div>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="24" :lg="24" :md="3" :sm="12" :xs="12">
                    <div class="global-search-btn">
                      <el-button class="search-btn" @click="searchedCases">
                        <div class="search-icon">
                          <span class="icon-hover">
                            <img
                              src="@/assets/images/search-icon-normal.svg"
                              alt="icon"
                              class="img-fluid"
                            />
                          </span>
                          <h4>SEARCH REPORTS</h4>
                        </div>
                      </el-button>
                      <el-button class="clear-filter" @click="resetAllFilters"
                        >CLEAR FILTERS</el-button
                      >
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </div>
      </div>
      <div class="all-cases-view">
        <div class="global-table-tabs"> 
          <div class="d-flex justify-content-end" v-if="tableVisible"> 
             <el-button
              class="btn button-with-icon"
              @click="onAnnualCount()"
            >
              <span>Annual Count</span>
             </el-button>
            <el-button
              class="btn button-with-icon"
              v-if="activeName === 'first'"
              @click="onReportsExport"
            >
              <span class="mr-8">
                <img
                  src="@/assets/images/icons/export-icon-with-bg-blue.svg"
                  alt="icon"
                  class="inactive"
                />
                <img
                  src="@/assets/images/icons/export-icon-white.svg"
                  alt="icon"
                  class="active"
                />
              </span>
              <span>Export</span>
            </el-button>
            <el-button
              class="btn button-with-icon"
              v-if="activeName === 'second'"
              @click="onOrdersExport"
            >
              <span class="mr-8">
                <img
                  src="@/assets/images/icons/export-icon-with-bg-blue.svg"
                  alt="icon"
                  class="inactive"
                />
                <img
                  src="@/assets/images/icons/export-icon-white.svg"
                  alt="icon"
                  class="active"
                />
              </span>
              <span>Export</span>
            </el-button>
          </div>
          <div class="test-panels">
            <el-tabs
              v-model="activeName"
              v-on:tab-click="updateSelectedTabQuery"
              v-if="tableVisible || loading"
            >
              <el-tab-pane label="CASES" name="first">
                <div class="primary-content-view-new mt-5">
                  <div
                    class="listings listings__table listings__all-cases"
                    id="all-cases-listings"
                  >
                    <el-table
                      :data="casesTable.data"
                      :default-sort="{
                        prop: orderBy,
                        order: orderType == 'asc' ? 'ascending' : 'descending',
                      }"
                      @sort-change="onChangeSort"
                    >
                      <el-table-column
                        fixed="left"
                        prop="accession_id"
                        label="ACCESSION ID"
                        min-width="150"
                        sortable="custom"
                      >
                        <template #default="scope">
                          <div class="name-accession">
                            <span
                              id="accession-id"
                              @click="goToCaseView(scope.row._id)"
                              >{{ scope.row.accession_id }}</span
                            >
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="Case Type"
                        min-width="135px"
                        prop="case_types"
                        sortable="custom"
                        fixed="left"
                      >
                        <template #default="scope">
                          <div
                            class="case-type"
                            v-if="
                              scope.row.case_types &&
                              scope.row.case_types.length > 1
                            "
                          >
                            <el-dropdown>
                              <span class="case-data-type">
                                {{ getCaseTypes(scope.row.case_types)[0] }}
                                <img
                                  src="@/assets/images/case-type-arrow.svg"
                                  alt="icon"
                                />
                              </span>

                              <template #dropdown>
                                <el-dropdown-menu class="case-type-dropdown">
                                  <el-dropdown-item
                                    class="cases-view"
                                    v-for="(caseType, index) of getCaseTypes(
                                      scope.row.case_types
                                    )"
                                    :key="index"
                                    >{{ caseType }}</el-dropdown-item
                                  >
                                </el-dropdown-menu>
                              </template>
                            </el-dropdown>
                          </div>
                          <div v-else class="case-type">
                            <span class="case-data-type">{{
                              getCaseTypes(scope.row.case_types)[0]
                            }}</span>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        fixed="left"
                        prop="patient_info.first_name"
                        label="PATIENT NAME"
                        min-width="150"
                        sortable="custom"
                      >
                        <template #default="scope">
                          <el-button
                            placement="top"
                            class="title-on-hover"
                            :title="
                              convertToUppercase(getPatientNameByInfo(scope.row.patient_info))
                            "
                            @click="
                              copyTitle(
                                getPatientNameByInfo(scope.row.patient_info)
                              )
                            "
                          >
                            <span class="text-center ordering_facility-value">{{
                              convertToUppercase(getPatientNameByInfo(scope.row.patient_info))
                            }}</span>
                          </el-button>
                        </template>
                      </el-table-column>
                      <el-table-column label="Patient DOB" min-width="100">
                        <template #default="scope">
                          {{ formatDate(scope.row.patient_info.date_of_birth) }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="ordering_facility"
                        label="ordering facilities"
                        min-width="250"
                      >
                        <template #default="scope">
                          <el-button
                            placement="top"
                            class="title-on-hover"
                            :title="
                              scope.row.hospital
                                ? scope.row.hospital.name
                                : '--'
                            "
                          >
                            <span class="ordering_facility-value">{{
                              scope.row.hospital
                                ? scope.row.hospital.name
                                : "--"
                            }}</span>
                          </el-button>
                        </template>
                      </el-table-column>
                      <el-table-column label="Physician" min-width="150">
                        <template #default="scope">
                          <el-button
                            placement="top"
                            class="title-on-hover"
                            :title="
                              scope.row.ordering_physician
                                ? scope.row.ordering_physician.name.includes(
                                    'Dr'
                                  )
                                  ? scope.row.ordering_physician.name
                                  : 'Dr ' + scope.row.ordering_physician.name
                                : '--'
                            "
                          >
                            <span class="ordering_physician-value">
                              {{
                                scope.row.ordering_physician
                                  ? scope.row.ordering_physician.name.includes(
                                      "Dr"
                                    )
                                    ? scope.row.ordering_physician.name
                                    : "Dr " + scope.row.ordering_physician.name
                                  : "--"
                              }}
                            </span>
                          </el-button>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="Collected On"
                        min-width="125"
                        prop="collection_date"
                        sortable="custom"
                      >
                        <template #default="scope">
                          <div class="d-flex align-items-center">
                            <div
                              class="date pr-10"
                              v-if="scope.row.collection_date"
                            >
                              {{
                                momentWithTimezone(
                                  scope.row.collection_date,
                                  "MM-DD-yyyy"
                                )
                              }}
                            </div>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="Received On"
                        min-width="125"
                        prop="received_date"
                        sortable="custom"
                      >
                        <template #default="scope">
                          <div class="d-flex align-items-center">
                            <div
                              class="date pr-10"
                              v-if="scope.row.received_date"
                            >
                              {{
                                momentWithTimezone(
                                  scope.row.received_date,
                                  "MM-DD-yyyy"
                                )
                              }}
                            </div>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="Reported On"
                        width="125"
                        prop="reported_at"
                      >
                        <template #default="scope">
                          <div class="d-flex align-items-center">
                            <div
                              class="date pr-10"
                              v-if="scope.row.reported_at"
                            >
                              {{
                                momentWithTimezone(
                                  scope.row.reported_at,
                                  "MM-DD-yyyy"
                                )
                              }}
                            </div>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="Amended At"
                        min-width="190"
                        v-if="hasAmendmentDate"
                      >
                        <template #default="scope">
                          <div class="d-flex">
                            <div
                              class="date pr-10"
                              v-if="scope.row.amendement_details"
                            >
                              {{
                                momentWithTimezone(
                                  scope.row.amendement_details.amendment_time,
                                  "MM-DD-yyyy"
                                )
                              }}
                            </div>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="Results"
                        min-width="160"
                        sortable="custom"
                        prop="covid_status"
                        v-if="hasCovidCaseType || hasCovidColumns"
                      >
                        <template #default="scope">
                          <div class="column-status">
                            <span
                              class="el-dropdown-link"
                              v-if="
                                hasCovid(scope.row) && scope.row.covid_status
                              "
                            >
                              <el-tag
                                :type="getStatusType(scope.row.covid_status)"
                              >
                                {{
                                  scope.row.covid_status.split("_").join(" ")
                                }}
                              </el-tag>
                            </span>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="Results"
                        width="180"
                        v-if="hasToxicologyCaseType || showToxColumn"
                      >
                        <template #default="scope">
                          <div
                            class="column-status"
                            v-if="scope.row.status == 'COMPLETE'"
                          >
                            <div class="date pr-10">
                              <el-tag
                                :type="getStatusType(resultStatus(scope.row))"
                              >
                                {{ resultStatus(scope.row) }}
                              </el-tag>
                            </div>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="Results"
                        width="180"
                        v-if="hasUtiRppCase || showResultColumn"
                      >
                        <template #default="scope">
                          <div
                            class="column-status"
                            v-if="scope.row.status == 'COMPLETE'"
                          >
                            <div class="date pr-10">
                              <el-tag
                                :type="
                                  getStatusType(reportResultStatus(scope.row))
                                "
                              >
                                {{ reportResultStatus(scope.row) }}
                              </el-tag>
                            </div>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="Case Status"
                        min-width="150"
                        sortable="custom"
                        prop="status"
                      >
                        <template #default="scope">
                          <div class="column-status" v-if="scope.row.status">
                            <span class="el-dropdown-link">
                              <el-tag :type="getStatusType(scope.row.status)">
                                {{
                                  scope.row.status === "COMPLETE"
                                    ? "FINALIZED"
                                    : scope.row.status === "TEST_REPORTS"
                                    ? "PROCESSING"
                                    : scope.row.status.split("_").join(" ")
                                }}
                              </el-tag>
                            </span>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="action"
                        label="REPORTS"
                        min-width="100"
                        fixed="right"
                      >
                        <template #default="scope">
                          <ul class="listings__action-buttons">
                            <li
                              v-if="
                                scope.row.status != 'ARCHIVED' &&
                                scope.row.status == 'COMPLETE'
                              "
                            >
                              <el-button
                                title="View Report"
                                class="reports-button"
                                @click="onViewReports(scope.row)"
                              >
                                <span
                                  class="beforeTestReportsIcon"
                                  v-if="
                                    checkNewReport(scope.row) &&
                                    checkCaseStatus(scope.row)
                                  "
                                >
                                  <img
                                    src="@/assets/images/icons/actions/beforeViewIcon.svg"
                                    alt="icon"
                                    style="width: 18px"
                                  />
                                </span>
                                <span class="afterTestReportsIcon" v-else>
                                  <img
                                    src="@/assets/images/icons/actions/afterViewIcon.svg"
                                    alt="icon"
                                    style="width: 18px"
                                  />
                                </span>
                              </el-button>
                            </li>
                          </ul>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="listings listings__pagination">
                    <el-pagination
                      v-model:currentPage="casesPage"
                      v-model:page-size="casesPageSize"
                      :page-sizes="[10, 20, 50, 100]"
                      layout=" prev, pager, next, jumper, sizes ,total"
                      :total="casesTable.total"
                      @size-change="loadCasesData"
                      @current-change="loadCasesPageChange"
                    />
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="ORDERS" name="second">
                <div class="primary-content-view-new mt-5">
                  <div
                    class="listings listings__table listings__all-cases"
                    id="all-cases-listings"
                  >
                    <el-table
                      :data="ordersTable.data"
                      :default-sort="{
                        prop: orderBy,
                        order: orderType == 'asc' ? 'ascending' : 'descending',
                      }"
                      @sort-change="onChangeSort"
                    >
                      <el-table-column
                        fixed="left"
                        prop="order_id"
                        label="ORDER ID"
                        min-width="180"
                        sortable="custom"
                      >
                        <template #default="scope">
                          <div class="name-accession">
                            <span
                              id="accession-id"
                              class="cursor"
                              @click="goToOrderView(scope.row._id)"
                              >{{ scope.row.order_id }}</span
                            >
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="Case Type"
                        min-width="140"
                        prop="case_types"
                        sortable="custom"
                        fixed="left"
                      >
                        <template #default="scope">
                          <div
                            class="case-type"
                            v-if="
                              scope.row.case_types &&
                              scope.row.case_types.length > 1
                            "
                          >
                            <el-dropdown>
                              <span class="case-data-type">
                                {{ getCaseTypes(scope.row.case_types)[0] }}
                                <img
                                  src="@/assets/images/case-type-arrow.svg"
                                  alt="icon"
                                />
                              </span>

                              <template #dropdown>
                                <el-dropdown-menu class="case-type-dropdown">
                                  <el-dropdown-item
                                    class="cases-view"
                                    v-for="(caseType, index) of getCaseTypes(
                                      scope.row.case_types
                                    )"
                                    :key="index"
                                    >{{ caseType }}</el-dropdown-item
                                  >
                                </el-dropdown-menu>
                              </template>
                            </el-dropdown>
                          </div>
                          <div v-else class="case-type">
                            <span class="case-data-type">{{
                              getCaseTypes(scope.row.case_types)[0]
                            }}</span>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        fixed="left"
                        prop="patient_info.first_name"
                        label="PATIENT NAME"
                        min-width="170"
                        sortable="custom"
                      >
                        <template #default="scope">
                          <div class="name-accession">
                            <el-button
                              placement="top"
                              class="title-on-hover"
                              :title="
                                convertToUppercase(getPatientNameByInfo(scope.row.patient_info))
                              "
                              @click="
                                copyTitle(
                                  getPatientNameByInfo(scope.row.patient_info)
                                )
                              "
                            >
                              <span
                                class="text-center ordering_facility-value"
                                >{{
                                  convertToUppercase(getPatientNameByInfo(scope.row.patient_info))
                                }}</span
                              >
                            </el-button>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column label="Patient DOB" min-width="140">
                        <template #default="scope">
                          {{ formatDate(scope.row.patient_info.date_of_birth) }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="ordering_facility"
                        label="ordering facilities"
                        min-width="200"
                      >
                        <template #default="scope">
                          <el-button
                            placement="top"
                            class="title-on-hover"
                            :title="
                              scope.row.hospital
                                ? scope.row.hospital.name
                                : '--'
                            "
                          >
                            <span class="ordering_facility-value">
                              {{
                                scope.row.hospital
                                  ? scope.row.hospital.name
                                  : "--"
                              }}</span
                            >
                          </el-button>
                        </template>
                      </el-table-column>
                      <el-table-column label="Physician" min-width="150">
                        <template #default="scope">
                          <el-button
                            placement="top"
                            class="title-on-hover"
                            :title="
                              scope.row.ordering_physician
                                ? scope.row.ordering_physician.name.includes(
                                    'Dr'
                                  )
                                  ? scope.row.ordering_physician.name
                                  : 'Dr ' + scope.row.ordering_physician.name
                                : '--'
                            "
                          >
                            <span class="ordering_facility-value">
                              {{
                                scope.row.ordering_physician
                                  ? scope.row.ordering_physician.name.includes(
                                      "Dr"
                                    )
                                    ? scope.row.ordering_physician.name
                                    : "Dr " + scope.row.ordering_physician.name
                                  : "--"
                              }}
                            </span>
                          </el-button>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="Collected On"
                        min-width="190"
                        prop="collection_date"
                        sortable="custom"
                      >
                        <template #default="scope">
                          <div class="d-flex">
                            <div
                              class="date pr-10"
                              v-if="scope.row.collection_date"
                            >
                              {{
                                momentWithTimezone(
                                  scope.row.collection_date,
                                  "MM-DD-yyyy"
                                )
                              }}
                            </div>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="Status"
                        min-width="140"
                        sortable="custom"
                        prop="status"
                      >
                        <template #default="scope">
                          <div class="column-status" v-if="scope.row.status">
                            <span
                              class="el-dropdown-link"
                              v-if="scope.row.status == 'COMPLETE'"
                            >
                              <el-tag :type="getStatusType(scope.row.status)"
                                >FINALIZED</el-tag
                              >
                            </span>
                            <span class="el-dropdown-link" v-else>
                              <el-tag :type="getStatusType(scope.row.status)">
                                {{ scope.row.status }}
                              </el-tag>
                            </span>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="accession_id"
                        label="ACCESSION ID"
                        min-width="290"
                        sortable="custom"
                      >
                        <template #default="scope">
                          <div
                            class="name-accession cursor"
                            v-if="
                              scope.row.accession_data &&
                              scope.row.accession_data.length
                            "
                          >
                            <span
                              id="accession-id-blue"
                              class="order-accession"
                              v-for="(acccession, index) in scope.row
                                .accession_data"
                              :key="index"
                              @click="caseView(acccession.case_id)"
                            >
                              {{ acccession.accession_id }}
                            </span>
                          </div>
                          <div
                            class="name-accession cursor"
                            @click="caseView(scope.row.case_id)"
                            v-else-if="scope.row.case_id"
                          >
                            <span
                              id="accession-id-blue"
                              class="order-accession"
                            >
                              {{ scope.row.accession_id }}
                            </span>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="listings listings__pagination">
                    <el-pagination
                      v-model:currentPage="ordersTable.page"
                      v-model:page-size="ordersPageSize"
                      :page-sizes="[10, 20, 50, 100]"
                      layout=" prev, pager, next, jumper, sizes ,total"
                      :total="ordersTable.total"
                      @size-change="loadOrdersData"
                      @current-change="loadOrdersPageChange"
                    />
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="default-modal">
    <el-dialog
      top="5vh"
      v-model="dialogVisible"
      :width="'90%'"
      :before-close="closeTestReportsDialog"
    >
      <div class="dialog-header">
        <span class="header-part">Test Reports</span>
        <el-button
          size="medium"
          class="el-white"
          type="info"
          plain
          @click="closeTestReportsDialog"
        >
          <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" />
        </el-button>
      </div>
      <TestReport
        :caseIdProp="selectedCaseId"
        :openPopup="true"
        :displayUploading="false"
      />
    </el-dialog>
  </div>
  <ExportCases
    v-if="exportReportsDialogVisisble"
    v-on:close="exportReportsDialogVisisble = false"
    :selected_dob="details.date_of_birth"
    :selected_case_types="search_case_type"
    :selected_hospital="search_hospital"
    :selected_physician="search_ordering_physician"
    :selected_user="search_assigned_to"
    :selected_marketer="hospital_marketer"
    :selected_string="accessionId"
    :search_case_statuses="search_case_status"
    :selected_from_date="start_date"
    :selected_to_date="end_date"
    :search_first_name="patient_name"
    :search_last_name="lastName"
    :selected_date_type="date_type"
    :selected_covid_status="search_covid_status"
    :selected_tests="test_info"
  >
  </ExportCases>
  <ExportOrders
    v-if="exportOrdersDialogVisisble"
    v-on:close="exportOrdersDialogVisisble = false"
    :selected_search_hospital="search_hospital"
    :selected_search_string="accessionId"
    :selected_search_ordering_physician="search_ordering_physician"
    :selected_case_types="search_case_type"
    :selected_dob="details.date_of_birth"
    :selected_marketer="hospital_marketer"
    :search_case_statuses="search_case_status"
    :selected_from_date="start_date"
    :selected_to_date="end_date"
    :search_first_name="patient_name"
    :search_last_name="lastName"
    :selected_date_type="date_type"
    :selected_tests="test_info"
  >
  </ExportOrders>
</template>

<script>
import { defineAsyncComponent } from "vue";
import caseConstants from "@/config/constants/caseConstants";
const dobVersion = defineAsyncComponent(() =>
  import("@/components/misc/DobNewFormat")
);
import { mapGetters } from "vuex";
import moment from "moment-timezone";
import FilterHelper from "@/mixins/FilterHelper";
import caseDataHelper from "@/mixins/caseDataHelper";

import AppHelper from "@/mixins/AppHelper";
const ExportCases = defineAsyncComponent(() =>
  import("@/components/cases/ExportCases")
);
const ExportOrders = defineAsyncComponent(() =>
  import("@/components/orders/ExportOrders")
);
const TestReport = defineAsyncComponent(() =>
  import("@/components/cases/ViewTestReport")
);
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  name: "",
  components: {
    dobVersion,
    ExportCases,
    ExportOrders,
    TestReport,
  },
  mixins: [FilterHelper, AppHelper, caseDataHelper],
  computed: {
    isLabUser() {
      if (this.getAuthenticatedUser && this.getAuthenticatedUser.user_type) {
        let users = [
          "ADMIN",
          "LAB_ADMIN",
          "LAB_TECHNOLOGIST",
          "LAB_MANAGER",
          "BILLING_REPRESENTATIVE",
          "LAB_DATA_ASSISTANT",
        ];
        if (users.indexOf(this.getAuthenticatedUser.user_type) !== -1) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
    getCaseTypes() {
      return (caseTypes) => {
        return (caseTypes || []).map((e) => this.caseTypeMap[e]);
      };
    },
    selectedCovidPanel() {
      return (
        this.search_case_type.indexOf("COVID") > -1 ||
        this.search_case_type.indexOf("COVID_FLU") > -1
      );
    },
    checkCaseStatus() {
      return (caseData) => {
        if (caseData.status === "COMPLETE") {
          return true;
        } else {
          return false;
        }
      };
    },
    checkNewReport() {
      return (caseData) => {
        if (caseData && caseData.test_reports && caseData.test_reports.length) {
          let newReport = caseData.test_reports.find((report) => {
            if (report.download_logs) {
              let userDownloadLog = report.download_logs.find(
                (e) => e.user_id === this.getAuthenticatedUser._id
              );
              if (userDownloadLog) {
                return false;
              } else {
                return true;
              }
            }
          });
          if (newReport) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      };
    },
    getStatusType() {
      return (statusVal) => {
        const status = statusVal;
        if (status == "ACTIVE") {
          return "default";
        } else if (status == "COMPLETE") {
          return "success";
        } else if (status == "TEST_REPORTS") {
          return "warning";
        } else if (status == "CANCELLED") {
          return "danger";
        } else if (status == "COMPLETED") {
          return "success";
        } else if (status == "TEST_RESULTS") {
          return "info";
        } else if (status == "CONSISTENT") {
          return "success";
        } else if (status == "INCONSISTENT") {
          return "warning";
        } else if (status == "POSITIVE") {
          return "danger";
        } else if (status == "NEGATIVE") {
          return "success";
        } else if (status == "INCONCLUSIVE") {
          return "info";
        } else if (status == "REJECTED") {
          return "darkDanger";
        } else if (status == "PENDING") {
          return "danger";
        } else {
          return "nullvalue";
        }
      };
    },
    getDateType() {
      let dateTypeMap = {
        collection_date: "Collection",
        received_date: "Received",
        finalized_date: "Reported",
        amended_date: "Amended",
      };
      return this.date_check.toString()
        ? dateTypeMap[this.date_check.toString()]
        : "";
    },
    hasCovidCaseType() {
      if (
        this.search_case_type == "COVID" ||
        this.search_case_type == "COVID_FLU"
      ) {
        return true;
      }
      return false;
    },
    hasCovidColumns() {
      if (this.casesTable && this.casesTable.data) {
        return this.casesTable.data.every(
          (item) =>
            item.case_types.includes("COVID") ||
            item.case_types.includes("COVID_FLU")
        );
      }
      return null;
    },
    showToxColumn() {
      if (this.casesTable && this.casesTable.data) {
        return this.casesTable.data.every((item) =>
          item.case_types.every((type) => type === "TOXICOLOGY")
        );
      }
      return null;
    },

    hasToxicologyCaseType() {
      if (this.search_case_type == "TOXICOLOGY") {
        return true;
      }
      return false;
    },
    showResultColumn() {
      if (this.casesTable && this.casesTable.data) {
        return this.casesTable.data.every(
          (item) =>
            item.case_types.includes("UTI") ||
            item.case_types.includes("RESPIRATORY_PATHOGEN_PANEL") ||
            item.case_types.includes("URINALYSIS")
        );
      }
      return null;
    },

    hasUtiRppCase() {
      if (
        this.search_case_type == "UTI" ||
        this.search_case_type == "RESPIRATORY_PATHOGEN_PANEL" ||
        this.search_case_type == "URINALYSIS"
      ) {
        return true;
      }
      return false;
    },
    hasAmendmentDate() {
      if (this.date_type === "amended_date") {
        return true;
      }
      return false;
    },
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("physicians", ["getAllPhysicians"]),
    ...mapGetters("cases", [
      "getGlobalSearchCases",
      "getTestReportsDownloadLog",
      "getTestReportsViewLog",
      "getAnnualCountDataStatus"
    ]),
    ...mapGetters("orders", ["getGlobalSearchOrders"]),
    ...mapGetters("profile", ["getTestPanelsData"]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    ...mapGetters("userAccounts", ["getAllUsers"]),
    ...mapGetters("labTests", [
      "getAllLabTests",
      "getNewLabGroupWiseTests",
      "getNewLabGroupPanelTests",
      "getNewLabGroupWiseTestsData",
    ]),
    ...mapGetters("errors", ["getErrors", "getError"]),
    reportResultStatus() {
      return (status) => {
        if (status) {
          const testReportsData = status.test_reports;

          for (let i = 0; i < testReportsData.length; i++) {
            if (testReportsData[i].mark_for_physician) {
              const resultStatus = testReportsData[i].result_status;

              return resultStatus;
            }
          }

          return "--";
        }

        return "--";
      };
    },
    resultStatus() {
      return (status) => {
        if (status) {
          const testReportsData = status.test_reports;

          for (let i = 0; i < testReportsData.length; i++) {
            if (testReportsData[i].mark_for_physician) {
              const resultStatus = testReportsData[i].result_status;

              if (resultStatus !== "POSITIVE" && resultStatus !== "NEGATIVE") {
                return resultStatus;
              }
            }
          }

          return "--";
        }

        return "--";
      };
    },
  },
  data() {
    return {
      test: "",
      orderBy: "created_at",
      orderType: "desc",
      exportOrdersDialogVisisble: false,
      exportReportsDialogVisisble: false,
      case_types: [],
      activeName: "first",
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      disabledDate: (time) => {
        return time.getTime() > Date.now();
      },
      covidStatuses: [
        {
          label: "POSITIVE",
          value: "POSITIVE",
        },
        {
          label: "NEGATIVE",
          value: "NEGATIVE",
        },
        {
          label: "INCONCLUSIVE",
          value: "INCONCLUSIVE",
        },
        {
          label: "RESULT AWAITED",
          value: "RESULT_AWAITED",
        },
      ],

      page: 1,
      casesTable: [],
      ordersTable: [],
      loading: false,
      date_type: "",
      date_check: [],
      details: {
        date_of_birth: null,
      },
      globalSearchCollapse: "1",
      from_date: "",
      to_date: "",
      patient_name: "",
      lastName: "",
      pageOrder: 1,
      casesPage: 1,
      ordersPage: 1,
      pageSize: 10,
      pageSizeOrder: 10,
      casesPageSize: 10,
      ordersPageSize: 10,
      limit: 10,
      start_date: null,
      end_date: null,
      search_case_type: [],
      search_covid_status: "",
      search_case_status: "",
      accessionId: "",
      search_hospital: [],
      search_ordering_physician: "",
      search_assigned_to: "",
      hospital_marketer: [],
      caseTypes: caseConstants.CASE_TYPES_DATA,
      caseStatuses: [
        {
          label: "ACTIVE",
          value: "ACTIVE",
        },
        {
          label: "PROCESSING",
          value: "TEST_REPORTS",
        },
        {
          label: "FINALIZED",
          value: "COMPLETE",
        },
        {
          label: "REJECTED",
          value: "REJECTED",
        },
      ],
      allFilters: "",
      archivePopup: false,
      patientInformation: {
        date_of_birth: "",
      },
      startDate: moment().subtract("0", "M"),
      minDate: moment().subtract("1", "M"),
      presentDate: moment(),
      datePickerOptions: {
        disabledDate(date) {
          return date > new Date();
        },
      },
      showDob: true,
      hospitalsData: {},
      physiciansData: {},
      hospitalsLoading: false,
      physiciansLoading: false,
      dialogVisible: false,
      selectedCaseId: null,
      usersLoading: false,
      usersList: [],
      marketerData: [],
      marketingManagerData: [],
      testIds: {},
      testNames: [],
      test_info: [],
      testsLoading: false,
      casesData: [],
    };
  },
  async mounted() {
    this.setQueryParams();

    this.fetchProfile();
    if (Object.keys(this.$route.query).length >= 1) {
      await this.defaultApplyfilters();
    }

    if (Object.keys(this.allFilters).length >= 3) {
      this.showDob = false;
      await this.searchedCases();
    }
    // Add Class to body on scroll
    window.addEventListener("scroll", this.onScroll);
  },
  async unmounted() {
    // Remove Class to body on scroll
    document.body.classList.remove("fixedNavbarOnComponent");
    window.removeEventListener("scroll", this.onScroll);
  },
  watch: {
    search_case_type: {
      immediate: true,
      handler: function () {
        this.clearTestInfo();
      },
    },
  },
  methods: {
    async onAnnualCount() {
      this.loading = true
      if (!this.start_date || !this.end_date) {
        this.$message.warning("Please select both start and end dates.");
        return;
      }
      try {
        await this.$store.dispatch("cases/annualCountTestInformation", {
          from_date: this.start_date,
          to_date: this.end_date
        });
          successNotification("Annual tests count data downloaded successfully")
        this.loading = false
      } catch (error) {
        this.$message.error("Failed to fetch annual count data.");
      } finally {
        this.loading = false
      }
    },
    async remoteMethodPhysician(query) {
      if (query !== "") {
        localStorage.setItem("searchQueryPhysician", query);
        await this.fetchPhysicians(query);
      }
    },
    clearTestInfo() {
      if (this.search_case_type.length === 0) {
        this.test_info = []; // Clear the test_info array
      }
    },
    async onScroll() {
      // Get the scroll position, you can adjust this value based on your requirement
      const scrollPosition = window.scrollY;
      // Add a class to the body element based on the scroll position
      // For example, adding a class 'scrolled' when the user scrolls more than 100px
      if (scrollPosition > 1) {
        document.body.classList.add("fixedNavbarOnComponent");
      } else {
        document.body.classList.remove("fixedNavbarOnComponent");
      }
    },
    handleTests() {
      this.fetchAllTestPanels();
    },
    async fetchAllTestPanels() {
      await this.$store.dispatch("labTests/fetchAllLabTests", {
        get_all: true,
        case_type_code: this.search_case_type,
      });
      if (this.getAllLabTests) {
        this.testNames = [];
        for (let caseData of this.getAllLabTests) {
          this.testNames.push(caseData);
        }
        this.testIds = {};
        let uniqueObject = {};
        if (this.caseType == "TOXICOLOGY") {
          this.testNames = this.testNames.map((e) => {
            if (
              e.category_code == "SCREENING" ||
              e.category_code == "SCREENING_VALIDITY"
            ) {
              e.category = "SCREENING";
            } else if (e.category_code == "ETG_ETS" || e.category_code == "ETG/ETS") {
              e.category = "ETG/ETS";
            } else {
              e.category = "CONFIRMATION";
            }
            return e;
          });
        }

        let categories = Array.from(
          new Set(this.testNames.map((e) => e.category))
        );

        this.testIds = categories.map((category) => {
          let tests = this.testNames
            .filter((t) => t.category == category)
            .map((e) => e._id);
          return {
            category,
            tests,
          };
        });
      } else {
        this.testNames = [];
        this.testIds = {};
      }
    },
    async fetchProfile() {
      await this.$store.dispatch("profile/fetchMyTestPanels", {
        include_test_details: true,
        get_all: true,
      });
    },
    removeCovidStatus(casetype) {
      if (casetype == "COVID" || casetype == "COVID_FLU") {
        this.search_covid_status = "";
      }
    },
    async testReportsDownloadLog(report, testReports) {
      let params = {
        case_id: report._id,
        report_id: testReports._id,
      };
      await this.$store.dispatch("cases/testReportsDownloadLog", params);
    },
    async testReportsViewLog(report, testReports) {
      let params = {
        case_id: report._id,
        report_id: testReports._id,
      };
      await this.$store.dispatch("cases/testReportsViewLog", params);
    },
    uniqueCheck(e) {
      this.date_check = [];
      if (e.target.checked) {
        this.date_check.push(e.target.value);
      }
      this.date_type = this.date_check.toString();
    },

    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "created_at";
        this.orderType = "desc";
      }
      this.fetchAll(this.page);
    },

    async onViewReports(report) {
      try {
        this.loading = true;
        let testReportsData = report.test_reports;

        for (let i = 0; i < testReportsData.length; i++) {
          await this.$store.dispatch("cases/generateTestReport", {
            accession_id: report.accession_id,
            case_type: report.case_type,
            report_id: testReportsData[i].report_id,
            test_results_id: testReportsData[i].test_results_id,
            result_file_id: testReportsData[i].result_file_id,
            skip_download: true,
          });
          if (
            (testReportsData[i].is_manually ||
              testReportsData[i].additional_report_merged ||
              testReportsData[i].additional_report_already_merged ||
              testReportsData[i].download_ready) &&
            testReportsData[i].mark_for_physician
          ) {
            let routerData = this.$router.resolve({
              name: "supplementaryReportView",
              params: {
                report_id: testReportsData[i]._id,
                case_id: report._id,
              },
            });
            window.open(routerData.href, "_blank");
          } else {
            if (testReportsData[i].mark_for_physician) {
              let routerData = this.$router.resolve({
                name: "ResultFileTestReports",
                params: {
                  report_id: testReportsData[i]._id,
                  case_id: report._id,
                },
              });
              window.open(routerData.href, "_blank");
            }
          }
          await this.testReportsViewLog(report, testReportsData[i]);
          await this.testReportsDownloadLog(report, testReportsData[i]);
          await this.reload();
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      } finally {
        this.loading = false;
      }
    }, 
    async reload() {
      this.setQueryParams();
      if (Object.keys(this.$route.query).length >= 1) {
        this.defaultApplyfilters();
      }

      if (Object.keys(this.allFilters).length >= 3) {
        this.showDob = false;
        await this.searchedCases();
      }
      // Add Class to body on scroll
      window.addEventListener("scroll", this.onScroll);
    },
    async onReportsExport() {
      this.loading = true;

      this.exportReportsDialogVisisble = true;
      this.loading = false;
    },
    async onOrdersExport() {
      this.exportOrdersDialogVisisble = true;
    },
    hasCovid(caseData) {
      return (
        caseData.case_types.indexOf("COVID") > -1 ||
        caseData.case_types.indexOf("COVID_FLU") > -1
      );
    },
    hasToxicology(caseData) {
      return caseData.case_types.indexOf("TOXICOLOGY") > -1;
    },
    resetAllFilters() {
      this.date_type = "";
      this.date_check = [];
      this.start_date = "";
      this.end_date = "";
      this.case_types = [];
      this.hospital = "";
      this.search_hospital = [];
      this.ordering_physician = "";
      this.fieldList = [];
      this.details = {
        date_of_birth: null,
      };
      this.end_data = "";
      this.start_data = "";
      this.search_ordering_physician = "";
      this.search_assigned_to = "";
      this.hospital_marketer = [];
      this.search_case_type = [];
      this.patient_name = "";
      this.lastName = "";
      this.search_case_status = "";
      this.search_covid_status = "";
      this.accessionId = "";
      this.test_info = [];
      this.search_hospital = [];
      this.$router.push({
        query: {},
      });
    },
    goToCaseView(case_id) {
      this.$router.push({
        name: "CaseView",
        params: { case_id: case_id },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    caseView(case_id) {
      this.$router.push({
        name: "CaseView",
        params: { case_id: case_id },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    goToOrderView(orderId) {
      this.$router.push({
        name: "Order-Information",
        params: { order_id: orderId },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    async loadCasesData(size) {
      this.pageSize = size;
      this.page = 1;
      this.casesPage = 1;
      let params = await this.buildParams();
      await this.fetchCases(params);
    },
    async loadOrdersData(size) {
      this.pageSizeOrder = size;
      this.page = 1;
      this.ordersPage = 1;
      let params = await this.buildParams();
      await this.fetchOrders(params);
    },
    async loadCasesPageChange(page) {
      this.casesPage = this.page = page;

      this.loading = true;
      let params = await this.buildParams();
      await this.fetchCases(params);
      this.loading = false;
    },
    async loadOrdersPageChange(page) {
      this.ordersPage = this.pageOrder = page;

      this.loading = true;
      let params = await this.buildParams();
      await this.fetchOrders(params);
      this.loading = false;
    },
    async updatePhysicians(hospitalId) {
      this.search_ordering_physician = "";
      let params = { get_all: true };
      if (this.search_hospital) {
        params.hospitals = this.search_hospital;
      }
      await this.$store.dispatch("physicians/fetchAllPhysicians", params);
      this.physiciansData = JSON.parse(JSON.stringify(this.getAllPhysicians));
    },
    defaultApplyfilters() {
      const params = this.buildParams();
      if (params.case_types && params.case_types.length < 1) {
        delete params.case_types;
      }
      this.allFilters = params;
    },
    setQueryParams() {
      if (this.$route.query) {
        if (this.$route.query.selectedSearchPage) {
          this.page = this.$route.query.selectedSearchPage
            ? parseInt(this.$route.query.selectedSearchPage)
            : 1;
          this.casesPage = this.page;
        }
        if (this.$route.query.selectedSearchPageSize) {
          this.pageSize =
            parseInt(this.$route.query.selectedSearchPageSize) || 10;
          this.casesPageSize = this.pageSize;
        }

        this.pageOrder = this.$route.query.selectedOrderSearchPage
          ? parseInt(this.$route.query.selectedOrderSearchPage)
          : 1;
        this.ordersPage = this.pageOrder;

        if (this.$route.query.selectedOrderSearchPageSize) {
          this.pageSizeOrder =
            parseInt(this.$route.query.selectedOrderSearchPageSize) || 10;
          this.ordersPageSize = this.pageSizeOrder;
        }
        if (this.$route.query.selectedSearchPanel) {
          this.activeName = this.$route.query.selectedSearchPanel;
        }
        if (
          this.$route.query.selectedSearchCaseType &&
          Array.isArray(this.$route.query.selectedSearchCaseType) &&
          this.$route.query.selectedSearchCaseType.length
        ) {
          this.search_case_type = this.$route.query.selectedSearchCaseType;
          this.fetchAllTestPanels();
        } else if (
          this.$route.query.selectedSearchCaseType &&
          this.$route.query.selectedSearchCaseType.length
        ) {
          this.search_case_type = [this.$route.query.selectedSearchCaseType];
          this.fetchAllTestPanels();
        }
        if (
          this.$route.query.selectedTest &&
          Array.isArray(this.$route.query.selectedTest) &&
          this.$route.query.selectedTest.length
        ) {
          this.fetchAllTestPanels();
          this.test_info = this.$route.query.selectedTest;
        } else if (
          this.$route.query.selectedTest &&
          this.$route.query.selectedTest.length
        ) {
          this.fetchAllTestPanels();
          this.test_info = [this.$route.query.selectedTest];
        }
        if (
          this.$route.query.selectedSearchHospital &&
          Array.isArray(this.$route.query.selectedSearchHospital) &&
          this.$route.query.selectedSearchHospital.length
        ) {
          this.fetchHospitals();
          this.search_hospital = this.$route.query.selectedSearchHospital;
        } else if (
          this.$route.query.selectedSearchHospital &&
          this.$route.query.selectedSearchHospital.length
        ) {
          this.search_hospital = [this.$route.query.selectedSearchHospital];
          this.fetchHospitals();
        }
        if (this.$route.query.selectedSearchPhysician) {
          const savedQuery = localStorage.getItem("searchQueryPhysician");
          if (savedQuery && this.$route.query.selectedString !== savedQuery) {
            this.fetchPhysicians(savedQuery);
          }
          this.search_ordering_physician =
            this.$route.query.selectedSearchPhysician;
        }
        if (this.$route.query.selectedTestReportsOpen) {
          this.dialogVisible =
            this.$route.query.selectedTestReportsOpen === "true" ? true : false;
        }
        if (this.$route.query.selectedCaseId) {
          this.selectedCaseId = this.$route.query.selectedCaseId;
        }
        if (this.$route.query.selectedSearchUser) {
          this.fetchAllUsers();
          this.search_assigned_to = this.$route.query.selectedSearchUser;
        }
        if (
          this.$route.query.selectedMarketer &&
          Array.isArray(this.$route.query.selectedMarketer) &&
          this.$route.query.selectedMarketer.length
        ) {
          this.hospital_marketer = this.$route.query.selectedMarketer;
          this.fetchAllUsers();
        } else if (
          this.$route.query.selectedMarketer &&
          this.$route.query.selectedMarketer.length
        ) {
          this.hospital_marketer = [this.$route.query.selectedMarketer];
          this.fetchAllUsers();
        }
        this.patient_name = this.$route.query.selectedSearchPatientName;
        this.lastName = this.$route.query.selectedSearchLastName;
        this.accessionId = this.$route.query.selectedSearchAccession;
        this.details.date_of_birth = this.$route.query.selectedSearchDob;
        this.search_covid_status = this.$route.query.selectedSearchCovidStatus;

        this.search_case_status = this.$route.query.selectedSearchStatus;
        this.start_date = this.$route.query.selectedSearchStartDate;
        this.end_date = this.$route.query.selectedSearchEndDate;
        if (this.$route.query.selectedDateType) {
          this.date_check.push(this.$route.query.selectedDateType);
          this.date_type = this.$route.query.selectedDateType;
        }
        this.orderBy = this.$route.query.selectedOrderBy;
        this.orderType = this.$route.query.selectedOrderType;
      } else {
        this.$route.query = {};
      }
    },
    updateSelectedTabQuery() {
      let query = {
        selectedSearchPanel: this.activeName,
        selectedSearchPage: this.$route.query.selectedSearchPage
          ? this.$route.query.selectedSearchPage
          : 1,
        selectedSearchPageSize: this.$route.query.selectedSearchPageSize
          ? this.$route.query.selectedSearchPageSize
          : 10,
        selectedOrderSearchPage: this.$route.query.selectedOrderSearchPage
          ? this.$route.query.selectedOrderSearchPage
          : 1,
        selectedOrderSearchPageSize: this.$route.query
          .selectedOrderSearchPageSize
          ? this.$route.query.selectedOrderSearchPageSize
          : 10,
        selectedSearchCaseType: this.$route.query.selectedSearchCaseType,
        selectedSearchHospital: this.$route.query.selectedSearchHospital,
        selectedSearchPhysician: this.$route.query.selectedSearchPhysician,
        selectedSearchUser: this.$route.query.selectedSearchUser,
        selectedMarketer: this.$route.query.selectedMarketer,
        selectedMarketingManager: this.$route.query.selectedMarketingManager,
        selectedSearchPatientName: this.$route.query.selectedSearchPatientName,
        selectedSearchLastName: this.$route.query.selectedSearchLastName,
        selectedSearchAccession: this.$route.query.selectedSearchAccession,
        selectedSearchDob: this.$route.query.selectedSearchDob,
        selectedSearchCovidStatus: this.$route.query.selectedSearchCovidStatus,
        selectedSearchStatus: this.$route.query.selectedSearchStatus,
        selectedDateType: this.$route.query.selectedDateType,
        selectedSearchStartDate: this.$route.query.selectedSearchStartDate,
        selectedSearchEndDate: this.$route.query.selectedSearchEndDate,
        selectedOrderBy: this.$route.query.selectedOrderBy,
        selectedOrderType: this.$route.query.selectedOrderType,
        selectedPregnancySearch: this.$route.query.selectedPregnancySearch,
        selectedTest: this.$route.query.selectedTest,
      };
      this.$router.replace({ query });
    },
    //update lab time
    buildParams() {
      let params = {};
      const dobField = this.$refs["dobField"];
      if (this.date_type) {
        params.date_type = this.date_type;
        if (!this.end_date && !this.start_date) {
          this.$message({
            message: "Please select Date",
            type: "warning",
          });
          this.loading = false;
          this.tableVisible = false;

          return null;
        }
      }
      if (this.end_date && this.end_date < this.start_date) {
        this.$message({
          message: "From date is greater than To date",
          type: "warning",
        });
        this.loading = false;
        this.tableVisible = false;

        return null;
      }
      if (this.end_date || this.start_date) {
        if (this.end_date) {
          let endDate = this.end_date;

          if (
            this.date_type == "collection_date" ||
            this.date_type == "received_date"
          ) {
            params.to_date = endDate;
          } else {
            params.to_date = endDate;
          }
        }
        if (this.start_date) {
          let startDate = this.start_date;

          if (
            this.date_type === "collection_date" ||
            this.date_type == "received_date"
          ) {
            params.from_date = startDate;
          } else {
            params.from_date = startDate;
          }
        }

        if (!this.date_type) {
          this.$message({
            message: "Please select Date Type!",
            type: "warning",
          });
          this.loading = false;
          this.tableVisible = false;

          return null;
        }
      }

      if (
        !this.details.date_of_birth &&
        dobField &&
        (dobField.date || dobField.year || dobField.month)
      ) {
        this.$message({
          message: "Please select valid DOB!",
          type: "warning",
        });
        this.loading = false;
        this.tableVisible = false;

        return null;
      }

      if (this.orderBy && this.orderType) {
        params.order_by = this.orderBy;
        params.order_type = this.orderType;
      } else {
        params.order_by = "created_at";
        params.order_type = "desc";
      }
      if (this.search_covid_status) {
        params.covid_status = this.search_covid_status;
      }
      if (this.search_case_status) {
        params.status = this.search_case_status;
      }
      if (this.search_case_type.length) {
        params.case_types = this.search_case_type;
      }
      if (this.test_info && this.test_info.length) {
        params.tests_info = [].concat.apply([], this.test_info);
      }
      if (this.search_ordering_physician) {
        params.ordering_physician = this.search_ordering_physician;
      }
      if (this.search_assigned_to) {
        params.test_performed_by = this.search_assigned_to;
      }
      if (this.hospital_marketer.length) {
        params.hospital_marketers = this.hospital_marketer;
      }
      if (this.search_hospital.length) {
        params.hospital = this.search_hospital;
      }
      if (this.patient_name) {
        params.patient_name = this.patient_name;
      }
      if (this.lastName) {
        params.last_name = this.lastName;
      }
      if (this.accessionId) {
        params.accession_id = this.accessionId;
      }
      if (this.details.date_of_birth) {
        params.patient_dob = this.details.date_of_birth;
      }
      console.log(params);
      if (Object.keys(params).length < 3) {
        this.$message({
          message: "Please select an option to search!",
          type: "warning",
        });
        this.loading = false;
        this.tableVisible = false;
        let query = {
          selectedSearchPage: undefined,
          selectedSearchPageSize: undefined,
          selectedSearchPanel: undefined,
        };
        this.$router.push({ query });
        return null;
      }
      if (this.details.date_of_birth) {
        var input = this.details.date_of_birth;
        if (input.length) {
          var date = moment(input);

          if (!date.isValid()) {
            this.$message({
              message: "Invalid DOB!",
              type: "warning",
            });
            this.loading = false;
            this.tableVisible = false;
          } else if (date > new Date()) {
            this.$message({
              message: "Future Dates Not Allowed",
              type: "warning",
            });
            this.loading = false;
            this.tableVisible = false;
            return null;
          }
        }
      }
      params.page = this.page;
      params.limit = this.pageSize;
      return params;
    },
    async fetchCases(paramsData, applyQuery = true) {
      let params = { ...paramsData };

      await this.$store.dispatch("cases/fetchGlobalSearchCasesData", params);
      this.casesTable = this.getGlobalSearchCases;
      if (this.getGlobalSearchCases && this.getGlobalSearchCases.data) {
        this.casesData = [...this.getGlobalSearchCases.data];
      } else {
        this.casesData = [];
      }
      if (applyQuery) {
        this.updateQueryParams(params);
      } else {
        this.updateQueryParam(this.$route.name, {}, true);
      }
    },
    async fetchOrders(paramsData, applyQuery = true) {
      let params1 = {};
      params1.limit = this.pageSizeOrder;
      params1.page = this.ordersPage;
      let params = { ...paramsData, ...params1 };

      this.loading = true;
      await this.$store.dispatch("orders/fetchGlobalSearchOrdersData", params);
      this.ordersTable = this.getGlobalSearchOrders;

      if (applyQuery) {
        this.updateOrderQueryParams(params);
      } else {
        this.updateQueryParam(this.$route.name, {}, true);
      }
      this.loading = false;
    },
    updateQueryParams(params) {
      let selectedParams = {
        selectedOrderSearchPage: this.$route.query.selectedOrderSearchPage,
        selectedOrderSearchPageSize:
          this.$route.query.selectedOrderSearchPageSize,
        selectedSearchPage: params.page,
        selectedSearchCaseType: params.case_types,
        selectedSearchPageSize: params.limit,
        selectedSearchPanel: this.activeName,
        selectedSearchHospital: params.hospital,
        selectedSearchPhysician: params.ordering_physician,
        selectedSearchUser: params.test_performed_by,
        selectedMarketer: params.hospital_marketers,
        selectedSearchDob: params.patient_dob,
        selectedSearchCovidStatus: params.covid_status,
        selectedSearchPatientName: params.patient_name,
        selectedSearchLastName: params.last_name,
        selectedSearchAccession: params.accession_id,
        selectedSearchStartDate: this.start_date,
        selectedSearchEndDate: this.end_date,
        selectedDateType: params.date_type,
        selectedOrderBy: params.order_by,
        selectedOrderType: params.order_type,
        selectedCaseId: this.$route.query.selectedCaseId,
        selectedTest: params.tests_info,
      };
      if (this.search_case_status) {
        selectedParams.selectedSearchStatus = params.status;
      }
      this.updateQueryParam(this.$route.name, selectedParams);
    },
    updateOrderQueryParams(params) {
      let selectedParams = {
        selectedSearchPage: this.$route.query.selectedSearchPage,
        selectedSearchPageSize: this.$route.query.selectedSearchPageSize,
        selectedOrderSearchPage: params.page,
        selectedSearchCaseType: params.case_types,
        selectedOrderSearchPageSize: params.limit,
        selectedSearchPanel: this.activeName,
        selectedSearchHospital: params.hospital,
        selectedSearchPhysician: params.ordering_physician,
        selectedSearchDob: params.patient_dob,
        selectedSearchCovidStatus: params.covid_status,
        selectedSearchPatientName: params.patient_name,
        selectedSearchLastName: params.last_name,
        selectedSearchAccession: params.accession_id,
        selectedSearchStartDate: this.start_date,
        selectedSearchEndDate: this.end_date,
        selectedDateType: params.date_type,
        selectedOrderBy: params.order_by,
        selectedOrderType: params.order_type,
        selectedTest: params.tests_info,
      };
      if (this.search_case_status) {
        selectedParams.selectedSearchStatus = params.status;
      }
      this.updateQueryParam(this.$route.name, selectedParams);
    },
    async closeTestReportsDialog() {
      let query = {
        selectedTestReportsOpen: undefined,
        selectedCaseId: undefined,
        selected_panel: undefined,
        selectedSearchPage: this.$route.query.selectedSearchPage,
        selectedSearchPageSize: this.$route.query.selectedSearchPageSize,
        selectedOrderSearchPage: this.$route.query.selectedOrderSearchPage,
        selectedSearchCaseType: this.$route.query.selectedSearchCaseType,
        selectedOrderSearchPageSize:
          this.$route.query.selectedOrderSearchPageSize,
        selectedSearchPanel: this.$route.query.selectedSearchPanel,
        selectedSearchHospital: this.$route.query.selectedSearchHospital,
        selectedSearchPhysician: this.$route.query.selectedSearchPhysician,
        selectedSearchDob: this.$route.query.selectedSearchDob,
        selectedSearchStatus: this.$route.query.selectedSearchStatus,
        selectedSearchCovidStatus: this.$route.query.selectedSearchCovidStatus,
        selectedSearchPatientName: this.$route.query.selectedSearchPatientName,
        selectedSearchLastName: this.$route.query.selectedSearchLastName,
        selectedSearchAccession: this.$route.query.selectedSearchAccession,
        selectedSearchStartDate: this.$route.query.selectedSearchStartDate,
        selectedSearchEndDate: this.$route.query.selectedSearchEndDate,
        selectedDateType: this.$route.query.selectedDateType,
        selectedOrderBy: this.$route.query.selectedOrderBy,
        selectedOrderType: this.$route.query.selectedOrderType,
        selectedPregnancySearch: this.$route.query.selectedPregnancySearch,
        selectedTest: this.$route.query.selectedTest,
      };
      this.$router.replace({ query });
      this.dialogVisible = false;
      this.fetchAll(this.page);
    },
    async searchedCases() {
      this.tableVisible = true;
      this.fetchAll(this.page);
    },
    async fetchAll(page) {
      this.loading = true;
      this.page = page;

      setTimeout(() => {
        this.showDob = true;
      }, 100);
      let params = this.buildParams();

      if (params) {
        this.tableVisible = true;

        // getting cases
        await this.fetchCases(params);

        // getting orders
        await this.fetchOrders(params);

        // this.globalSearchCollapse = "";
      }
      this.loading = false;
    },
    async fetchPhysicians(physician) {
      this.physiciansLoading = true;
      let params = {
        limit: 25,
      };
      if (physician) {
        params.search_string = physician;
      }
      await this.$store.dispatch("physicians/fetchAllPhysicians", params);
      this.physiciansData = JSON.parse(JSON.stringify(this.getAllPhysicians));
      this.physiciansLoading = false;
    },
    async fetchAllUsers() {
      this.usersLoading = true;
      await this.$store.dispatch("userAccounts/fetchAllUserAccounts", {
        get_all: true,
        order_by: "first_name",
        order_type: "asc",
        status:"ACTIVE"
      });
      if (this.getAllUsers && this.getAllUsers.data) {
        let usersForTestPerofmed = ["LAB_TECHNOLOGIST"];
        this.usersList = this.getAllUsers.data.filter((item) =>
          usersForTestPerofmed.includes(item.user_type)
        );
        let marketer = ["MARKETER"];
        this.marketerData = this.getAllUsers.data.filter((item) =>
          marketer.includes(item.user_type)
        );
      }
      this.usersLoading = false;
    },
    async fetchHospitals() {
      this.hospitalsLoading = true;
      await this.$store.dispatch("hospitals/fetchAllHospitals", {
        get_all: true,
        status:"ACTIVE"
      });
      this.hospitalsData = JSON.parse(JSON.stringify(this.getAllHospitals));
      this.hospitalsLoading = false;
    },
  },
};
</script>

<style lang="scss">
.global-search-collapse-block {
  margin-top: 1rem;
  .global-search-body {
    border-top: 1px solid #e7e7f7;
    background: #ffffff;
    .global-list {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 0.3em 2rem 0 2rem;

      .checkbox-header {
        line-height: 23px;
        color: #273480;
        font-weight: 600;
        font-size: 14px;
      }
      .search-checkbox {
        margin-left: 10px;
        .el-checkbox:last-of-type {
          border: none;
        }
        .el-checkbox__label {
          color: #34495e;
          padding-left: 6px;
        }
        .el-checkbox__inner {
          background: #ffffff;
          border: 1.6px solid rgba(156, 156, 156, 0.5);
          box-sizing: border-box;
          border-radius: 3.84px;
          width: 17px;
          height: 17px;
        }
      }
      li {
        display: flex;
        align-items: center;
        column-gap: 20px;
      }
      .radio-block {
        h3 {
          font-size: 15px;
        }
        label {
          display: flex;
          align-items: center;

          .input-checkbox {
            margin: 0px 7px;
            position: relative;
            top: -1px;
            cursor: pointer;
            outline: none !important;
            box-shadow: 0px 0px 0px 1px #fff;
            &:after {
              content: "";
              position: absolute;
              top: -2px;
              right: -2px;
              bottom: -2px;
              left: -2px;
              border: 1.27955px solid #9c9c9c;
              border-radius: 3.83865px;
              @media (min-width: 1200px) and (max-width: 1700px) {
                top: -2.5px;
                right: -1.5px;
                bottom: -1.5px;
                left: -2.5px;
              }
            }
            &:before {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: #fff !important;
            }
            &:focus {
              outline: none !important;
            }
            &:checked {
              &:before {
                background: transparent !important;
              }
            }
          }
        }
      }
    }
    .global-search-creation__body {
      border-top: 1px solid #e7e7f7;
      padding: 15px 30px 0 30px;

      .date-of-birth-row {
        .el-select .el-input__inner {
          height: 30px;
          background: #ffffff;
          border: 0.72px solid rgba(156, 156, 156, 0.8);
          box-sizing: border-box;
          border-radius: 2px;
        }
      }
    }
    .global-search-btn {
      display: flex;
      padding-top: 10px;
      padding-bottom: 10px;
      align-items: center;
      justify-content: center;
      .el-button {
        background: #273480;
        border: none;
        box-sizing: border-box;
        border-radius: 2px;
      }
    }
  }
  .global-search-btn {
    display: flex;
    padding-top: 20px;
    align-items: center;
    justify-content: flex-end;
    .el-button {
      background: #273480;
      border: none;
      box-sizing: border-box;
      border-radius: 5px;
      min-height: 30px;
      padding: 0px 15px;
      line-height: 4px;
      color: #ffffff;
      &.clear-filter {
        background-color: #f24a55;
        color: #ffffff;
        margin: 0 10px;
      }
      &.search-btn {
        &:hover,
        &:active {
          background: #273480;
          color: #ffffff;
          .search-icon {
            display: flex;
            align-items: center;

            .icon-default {
              padding: 0 5px;
              display: none;
              margin-bottom: 2px;
              img {
                width: 15px;
              }
            }
          }
        }
        .search-icon {
          display: flex;
          align-items: center;
          .icon-hover {
            display: block;
            img {
              width: 16px;
              margin-right: 5px;
            }
          }
          .icon-default {
            padding: 0 5px;
            margin-bottom: 2px;
            img {
              width: 17px;
            }
          }
        }
      }
    }
  }
}
.global-table-tabs {
  margin-top: 1em;
  .test-panels {
    .el-tabs__header {
      margin: 0;
    }
    .el-tabs__nav-wrap::after {
      width: 21%;
    }
    .el-tabs__active-bar {
      background-color: #0a5da6;
      border-radius: 25px;

      opacity: 0.8;
      border-radius: 5px;
    }
    .el-tabs__item {
      font-weight: 500;
      font-size: 14px;
      line-height: 23px;
      text-align: center;
      text-transform: capitalize;
      color: #828282;
      height: 30px;
    }
    .el-tabs__item.is-active {
      color: #0a5da6;
      font-weight: 500;
      font-size: 14px;
      line-height: 23px;

      text-align: center;
      text-transform: capitalize;
    }
  }
  .column-status {
    .el-tag {
      cursor: default;
    }
  }
}
.pregancy-field {
  display: flex;
  align-items: center;
  margin-top: 15px;
  margin-left: 10px;
  label {
    font-weight: 500;
    font-size: 15px;
    line-height: 100%;
    color: #000000;
  }
  .el-checkbox {
    height: auto;
    position: relative;
    top: 3px;
    left: 10px;
  }
  .el-form-item {
    margin-bottom: 0;
  }

  .el-checkbox-group {
    .el-checkbox {
      height: 20px;
    }

    .el-checkbox__input .el-checkbox__inner {
      border-color: transparent;
      box-shadow: 0 0 0 1px #ced1d6;
      border-radius: 4px;
      width: 17px;
      height: 17px;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner {
      background: #273480;
      border-color: #ffffff;
      box-shadow: 0 0 0 1px #ced1d6;
      width: 17px;
      height: 17px;
    }
    .el-checkbox__inner::after {
      box-sizing: content-box;
      content: "";
      border: 2px solid var(--el-checkbox-checked-icon-color);
      border-left: 0;
      border-top: 0;
      height: 9px;
      left: 5px;
      position: absolute;
      top: 1px;
      transform: rotate(45deg) scaleY(1);
      width: 3px;
      transition: transform 0.15s ease-in 50ms;
      transform-origin: center;
    }

    .el-checkbox__label {
      color: #34495e;
    }
  }
}
</style>
